const startPage: Record<string, Record<string, string> | string> = {
    productName: 'Module Expertise',
    productDescription: 'Automation of the process of conducting an independent examination',
};

export default startPage;
